/**
 * Available font names for FontProvider + Tailwind safelist.
 * Keep in sync with index.html and tailwind.config.js fontFamily.
 */
export const fonts = ['inter', 'manrope', 'system'] as const
